import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const FadeUp = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.75, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "", inView = false }) => {
  const anim = { y: 0, transition: { duration: 0.95, delay, ease: EASE } };
  return (
    <span className={`block overflow-hidden ${className}`}>
      {inView ? (
        <motion.span className="block" initial={{ y: "112%" }} whileInView={anim} viewport={{ once: true, margin: "-40px" }}>
          {children}
        </motion.span>
      ) : (
        <motion.span className="block" initial={{ y: "112%" }} animate={anim}>
          {children}
        </motion.span>
      )}
    </span>
  );
};

export const Eyebrow = ({ children, dark = false, className = "" }) => (
  <p
    className={`font-mono text-[10px] md:text-[11px] uppercase tracking-[0.35em] flex items-center gap-3 ${
      dark ? "text-champagne" : "text-golddark"
    } ${className}`}
  >
    <span className="inline-block h-px w-8 bg-current opacity-70" aria-hidden="true" />
    {children}
  </p>
);
